import styled from 'styled-components';

export const PageContainer = styled.div`
    width: 100%;
    min-width: 0;
    max-width: 100%;
    min-height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    ${({ $centered }) =>
        $centered &&
        `
        align-items: stretch;
        padding: clamp(8px, 2vw, 16px);
        overflow: hidden;
    `}
`;

export const PageContent = styled.div`
    flex: 1;
    min-width: 0;
    overflow-y: auto;
`;

export const BlockedContent = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    margin-top: clamp(16px, 3vw, 24px);
    padding: clamp(24px, 5vw, 48px) clamp(16px, 3vw, 24px);

    p {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.gray[600]};
        text-align: center;
    }
`;
